import _ from 'lodash';

// import class1Routes from 'modules/OlympicSGKModule/routes/book1';
// import class2Routes from 'modules/OlympicSGKModule/routes/book2';
// import class3Routes from 'modules/OlympicSGKModule/routes/book3';
// import class4Routes from 'modules/OlympicSGKModule/routes/book4';
// import class5Routes from 'modules/OlympicSGKModule/routes/book5';

import publicRoutes from './publicRoutes';
import studentRoutes from './studentRoutes';
import teacherRoutes from './teacherRoutes';
import adminRoutes from "./adminRoutes";

// Olympic (Admin Area)

// export default _.concat(publicRoutes, studentRoutes, teacherRoutes, olympicRoutes, adminRoutes, class1Routes, class2Routes, class3Routes, class4Routes, class5Routes);
const shareRoutes = _.concat(publicRoutes, studentRoutes, teacherRoutes, adminRoutes);

export default shareRoutes;
